export const breakpoints = {
  tablet: 660,
  desktop: 1025,
};

export const mediaQueries = {
  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
};
